"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(boolFromString),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(boolFromBoxedPrimitive),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(boolFromCodecBoolValue),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(boolFromCodecBoolError),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(boolFromTypeValueInput),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(boolFromCodecUdvtValue),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(boolFromCodecUdvtError),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(boolFromOther);

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boolCases = void 0;

var debug_1 = __importDefault(require("debug"));

var debug = debug_1.default("codec:wrap:bool");

var dispatch_1 = require("./dispatch");

var errors_1 = require("./errors");

var Utils = __importStar(require("./utils"));

var Messages = __importStar(require("./messages"));

var boolCasesBasic = [boolFromString, boolFromBoxedPrimitive, boolFromCodecBoolValue, boolFromCodecBoolError, boolFromCodecUdvtValue, boolFromCodecUdvtError, boolFromOther //must go last!
];
exports.boolCases = [boolFromTypeValueInput].concat(boolCasesBasic);

function boolFromString(dataType, input, wrapOptions) {
  var asBoolean;
  return _regeneratorRuntime.wrap(function boolFromString$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof input !== "string")) {
            _context.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a string");

        case 2:
          //strings are true unless they're falsy or the case-insensitive string "false"
          asBoolean = Boolean(input) && input.toLowerCase() !== "false";
          return _context.abrupt("return", {
            type: dataType,
            kind: "value",
            value: {
              asBoolean: asBoolean
            }
          });

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function boolFromBoxedPrimitive(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function boolFromBoxedPrimitive$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (Utils.isBoxedPrimitive(input)) {
            _context2.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a boxed primitive");

        case 2:
          return _context2.delegateYield(dispatch_1.wrapWithCases(dataType, input.valueOf(), wrapOptions, exports.boolCases), "t0", 3);

        case 3:
          return _context2.abrupt("return", _context2.t0);

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function boolFromCodecBoolValue(dataType, input, wrapOptions) {
  var asBoolean;
  return _regeneratorRuntime.wrap(function boolFromCodecBoolValue$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (Utils.isWrappedResult(input)) {
            _context3.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a wrapped result");

        case 2:
          if (!(input.type.typeClass !== "bool")) {
            _context3.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.wrappedTypeMessage(input.type));

        case 4:
          if (!(input.kind !== "value")) {
            _context3.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, //only specificity 1 due to BoolError case
          Messages.errorResultMessage);

        case 6:
          asBoolean = input.value.asBoolean;
          return _context3.abrupt("return", {
            type: dataType,
            kind: "value",
            value: {
              asBoolean: asBoolean
            }
          });

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function boolFromCodecBoolError(dataType, input, wrapOptions) {
  var allowedErrors;
  return _regeneratorRuntime.wrap(function boolFromCodecBoolError$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (Utils.isWrappedResult(input)) {
            _context4.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a wrapped result");

        case 2:
          if (!(input.type.typeClass !== "bool")) {
            _context4.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.wrappedTypeMessage(input.type));

        case 4:
          if (!(input.kind !== "error")) {
            _context4.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was a value rather than an error");

        case 6:
          //these two error types will be regarded as true
          allowedErrors = ["BoolOutOfRangeError", "BoolPaddingError"];

          if (allowedErrors.includes(input.error.kind)) {
            _context4.next = 9;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.errorResultMessage);

        case 9:
          return _context4.abrupt("return", {
            type: dataType,
            kind: "value",
            value: {
              asBoolean: true
            }
          });

        case 10:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function boolFromTypeValueInput(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function boolFromTypeValueInput$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (Utils.isTypeValueInput(input)) {
            _context5.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a type/value pair");

        case 2:
          if (!(input.type !== "bool")) {
            _context5.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.specifiedTypeMessage(input.type));

        case 4:
          return _context5.delegateYield(dispatch_1.wrapWithCases(dataType, input.value, Object.assign(Object.assign({}, wrapOptions), {
            loose: true
          }), boolCasesBasic), "t0", 5);

        case 5:
          return _context5.abrupt("return", _context5.t0);

        case 6:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function boolFromCodecUdvtValue(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function boolFromCodecUdvtValue$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (Utils.isWrappedResult(input)) {
            _context6.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a wrapped result");

        case 2:
          if (!(input.type.typeClass !== "userDefinedValueType")) {
            _context6.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, Messages.wrappedTypeMessage(input.type));

        case 4:
          if (!(input.kind !== "value")) {
            _context6.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.errorResultMessage);

        case 6:
          return _context6.delegateYield(boolFromCodecBoolValue(dataType, input.value, wrapOptions), "t0", 7);

        case 7:
          return _context6.abrupt("return", _context6.t0);

        case 8:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function boolFromCodecUdvtError(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function boolFromCodecUdvtError$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          if (Utils.isWrappedResult(input)) {
            _context7.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a wrapped result");

        case 2:
          if (!(input.type.typeClass !== "userDefinedValueType")) {
            _context7.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, Messages.wrappedTypeMessage(input.type));

        case 4:
          if (!(input.kind !== "error")) {
            _context7.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was a value rather than an error");

        case 6:
          if (!(input.error.kind !== "WrappedError")) {
            _context7.next = 8;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.errorResultMessage);

        case 8:
          return _context7.delegateYield(boolFromCodecBoolError(dataType, input.error.error, wrapOptions), "t0", 9);

        case 9:
          return _context7.abrupt("return", _context7.t0);

        case 10:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function boolFromOther(dataType, input, wrapOptions) {
  var asBoolean;
  return _regeneratorRuntime.wrap(function boolFromOther$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (!Utils.isWrappedResult(input)) {
            _context8.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was a wrapped result");

        case 2:
          if (!Utils.isTypeValueInput(input)) {
            _context8.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was a type/value pair");

        case 4:
          asBoolean = Boolean(input);
          return _context8.abrupt("return", {
            type: dataType,
            kind: "value",
            value: {
              asBoolean: asBoolean
            }
          });

        case 6:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}